import { LegalFooter } from "../pages/LegalLot11B";
import React, { useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { House, CalendarDays, Trophy, Crown, UserRound, ArrowUpRight } from "lucide-react";
import { cn } from "../lib/utils";
import PublicSupport from "./PublicSupport"; // PROSCORE_ADMIN_DASHBOARD_LOT10_20261027
import { useAccess } from "../context/AccessContext";

const NAV = [
  { to: "/", label: "Accueil", mobile: "Accueil", Icon: House, end: true },
  { to: "/matchs", label: "Matchs", mobile: "Matchs", Icon: CalendarDays },
  { to: "/competitions", label: "Compétitions", mobile: "Ligues", Icon: Trophy },
  { to: "/coupon", label: "Sélection Pro", mobile: "Pro", Icon: Crown },
  { to: "/compte", label: "Compte", mobile: "Compte", Icon: UserRound },
];

function Brand() {
  return (
    <Link to="/" data-testid="nav-logo" className="ps-brand" aria-label="ProScore Live — Accueil">
      <img src="/proscore-brand/proscore-icon-512.png?v=mono-20261028" alt="" width="36" height="36" />
      <span>ProScore <strong>Live</strong></span>
    </Link>
  );
}

export function Layout({ children }) {
  const location = useLocation();
  const { user, loading: authLoading } = useAccess();
  // Visiteur non connecté : l'onglet Pro ouvre immédiatement la formule 19 $.
  // Abonné connecté : accès à la vraie Sélection Pro (autorisation vérifiée côté serveur).
  const proDestination = !authLoading && !user ? "/offres#selections-pro" : "/coupon";
  const activeTab = location.pathname === "/offres" && location.hash === "#selections-pro"
    ? 3 : NAV.findIndex(item => item.to === '/'
    ? location.pathname === '/'
    : location.pathname === item.to ||
      location.pathname.startsWith(item.to + '/') ||
      (item.to === '/matchs' &&
       location.pathname.startsWith('/matches')));
  useEffect(() => {
    if (!location.hash) window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location.pathname, location.hash]);

  return (
    <div className={`ps-app-shell${["/confidentialite", "/conditions-utilisation", "/mentions-legales", "/cookies"].includes(location.pathname) ? " ps-legal-route" : ""}`}>
      <a href="#main-content" className="ps-skip-link">Aller au contenu</a>
      <header className="ps-topbar sticky top-0 z-50">
        <div className="ps-topbar-inner">
          <Brand />
          <nav className="ps-desktop-nav" aria-label="Navigation principale">
            {NAV.filter(item => item.to !== "/compte").map(item => (
              <NavLink key={item.to} to={item.to === "/coupon" ? proDestination : item.to} end={item.end}
                data-testid={`nav-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) => cn("ps-nav-link", isActive && "is-active")}
              >{item.label}</NavLink>
            ))}
            <NavLink to="/offres" data-testid="nav-link-offres"
              className={({ isActive }) => cn("ps-nav-link", isActive && "is-active")}>Offres</NavLink>
          </nav>
          <div className="ps-top-actions">
            <Link to="/offres" className="ps-mobile-offers">Offres <ArrowUpRight size={14} aria-hidden="true" /></Link>
            <NavLink to="/compte" data-testid="nav-account-status" className="ps-account-link" aria-label="Mon compte">
              <UserRound size={19} aria-hidden="true" /> <span>Compte</span>
            </NavLink>
          </div>
        </div>
      </header>
      <main id="main-content" className="ps-app-main">{children}</main>
      <footer className="ps-footer">
        <div className="ps-footer-inner ps-l11c-footer-inner">
          <div className="ps-l11c-footer-copy">
            <p>© {new Date().getFullYear()} ProScore Live</p>
            <p>Analyses sportives et projections statistiques. Les résultats ne sont jamais garantis.</p>
          </div>
          <nav className="ps-l11c-primary" aria-label="Liens pratiques">
            <Link to="/offres">Offres</Link>
            <Link to="/compte">Compte</Link>
          </nav>
          <LegalFooter />
          <PublicSupport />
        </div>
      </footer>
      <nav
        className="ps-bottom-nav ps-v8-nav"
        aria-label="Navigation mobile"
        style={{
          '--ps-v8-shift': `${Math.max(activeTab, 0) * 100}%`,
          '--ps-v8-opacity': activeTab < 0 ? 0 : 1
        }}
      >
        <span
          className="ps-v8-nav-pill"
          aria-hidden="true"
        />
        {NAV.map(({ to, label, mobile, Icon, end }) => (
          <NavLink key={to} to={to === "/coupon" ? proDestination : to} end={end} aria-label={label}
            data-testid={`mobile-nav-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
            className={({ isActive }) => cn("ps-bottom-item", (isActive || (to === "/coupon" && location.pathname === "/offres" && location.hash === "#selections-pro")) && "is-active")}>
            <Icon size={19} aria-hidden="true" /> <span>{mobile}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
